/* HEAVELYN — product.js
   Variant picker (swatches + size buttons), price/stock updates,
   add-to-cart via cart drawer, sticky bar sync, recently-viewed capture. */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var productData = JSON.parse(document.querySelector('[data-product-json]').textContent);
  var form = root.querySelector('form[data-product-form]');
  if (!form) {
    // Bundle-driven template: sticky bar + recently-viewed only (bundle.js handles the rest)
    if (window.recentlyViewed) {
      window.recentlyViewed.add({
        handle: productData.handle,
        title: productData.title,
        url: root.getAttribute('data-product-url'),
        image: root.getAttribute('data-product-image') || '',
        meta: root.getAttribute('data-product-meta') || '',
        price: window.formatMoney ? window.formatMoney(productData.price) : ''
      });
    }
    return;
  }
  var idInput = form.querySelector('input[name="id"]');
  var lowStockThreshold = parseInt(root.getAttribute('data-low-stock-threshold'), 10) || 6;

  var els = {
    price: root.querySelectorAll('[data-price]'),
    comparePrice: root.querySelectorAll('[data-compare-price]'),
    installments: root.querySelector('[data-installments]'),
    stock: root.querySelector('[data-stock-note]'),
    submit: form.querySelector('[data-submit]'),
    submitText: form.querySelector('[data-submit-text]'),
    stickyVariant: document.querySelectorAll('[data-sticky-variant]'),
    optionValues: {} // optionName -> label element
  };

  root.querySelectorAll('[data-option-value-label]').forEach(function (el) {
    els.optionValues[el.getAttribute('data-option-value-label')] = el;
  });

  function selectedOptions() {
    var options = [];
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var checked = group.querySelector('[aria-checked="true"]');
      if (checked) options[parseInt(group.getAttribute('data-option-index'), 10)] = checked.getAttribute('data-value');
    });
    return options;
  }

  function findVariant(options) {
    return productData.variants.find(function (v) {
      return options.every(function (value, i) { return v.options[i] === value; });
    });
  }

  function updateAvailability(options) {
    // For each option group, disable values with no available variant given other selections.
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      group.querySelectorAll('[data-value]').forEach(function (btn) {
        var candidate = options.slice();
        candidate[index] = btn.getAttribute('data-value');
        var variant = findVariant(candidate);
        var available = variant && variant.available;
        if (btn.classList.contains('size-btn')) {
          btn.disabled = !available;
        } else {
          btn.setAttribute('data-unavailable', available ? 'false' : 'true');
        }
      });
    });
  }

  function money(cents) { return window.formatMoney(cents); }

  function update() {
    var options = selectedOptions();
    var variant = findVariant(options);

    Object.keys(els.optionValues).forEach(function (name) {
      var optIndex = productData.options.indexOf(name);
      if (optIndex > -1) els.optionValues[name].textContent = options[optIndex];
    });

    updateAvailability(options);

    if (!variant) {
      els.submit.disabled = true;
      els.submitText.textContent = els.submit.getAttribute('data-text-unavailable');
      return;
    }

    idInput.value = variant.id;
    els.submit.disabled = !variant.available;

    els.price.forEach(function (el) { el.textContent = money(variant.price); });
    els.comparePrice.forEach(function (el) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        el.textContent = money(variant.compare_at_price);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    if (els.installments) {
      els.installments.textContent = money(Math.round(variant.price / 4));
    }

    if (els.stock) {
      var qty = variant.inventory_quantity;
      var managed = variant.inventory_management != null;
      if (variant.available && managed && qty > 0 && qty <= lowStockThreshold) {
        var tpl = els.stock.getAttribute('data-template');
        els.stock.textContent = tpl
          .replace('[count]', qty)
          .replace('[variant]', variant.title.split(' / ').join(' · '));
        els.stock.hidden = false;
      } else {
        els.stock.hidden = true;
      }
    }

    els.submitText.textContent = variant.available
      ? els.submit.getAttribute('data-text-add') + ' — ' + money(variant.price)
      : els.submit.getAttribute('data-text-soldout');

    els.stickyVariant.forEach(function (el) {
      el.textContent = variant.title.split(' / ').join(' · ') + ' · ' + money(variant.price);
    });

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-value]');
    if (!btn || btn.disabled) return;
    var group = btn.closest('[data-option-index]');
    if (!group) return;
    group.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
    btn.setAttribute('aria-checked', 'true');
    update();
  });

  form.addEventListener('submit', function (e) {
    if (!window.addToCart) return; // fall back to normal submit
    e.preventDefault();
    els.submit.setAttribute('aria-busy', 'true');
    window.addToCart(new FormData(form)).catch(function (err) {
      if (err && err.description) alert(err.description);
    }).finally(function () {
      els.submit.removeAttribute('aria-busy');
    });
  });

  /* Sticky bar buttons mirror the main form */
  document.querySelectorAll('[data-sticky-submit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  update();

  /* reserve room for the fixed sticky bar so it never covers the footer */
  if (document.querySelector('.sticky-atc')) {
    document.body.classList.add('has-sticky-atc');
  }

  /* recently viewed capture */
  if (window.recentlyViewed) {
    var meta = root.getAttribute('data-product-meta');
    window.recentlyViewed.add({
      handle: productData.handle,
      title: productData.title,
      url: root.getAttribute('data-product-url'),
      image: root.getAttribute('data-product-image') || '',
      meta: meta || '',
      price: money(productData.price)
    });
  }
})();
